var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.7,384c0-11.8,9.6-21.3,21.3-21.3h128c11.8,0,21.3,9.6,21.3,21.3s-9.6,21.3-21.3,21.3H192 C180.2,405.3,170.7,395.8,170.7,384z M85.3,256c0-11.8,9.6-21.3,21.3-21.3h298.7c11.8,0,21.3,9.6,21.3,21.3s-9.6,21.3-21.3,21.3 H106.7C94.9,277.3,85.3,267.8,85.3,256z M0,128c0-11.8,9.6-21.3,21.3-21.3h469.3c11.8,0,21.3,9.6,21.3,21.3s-9.6,21.3-21.3,21.3 H21.3C9.6,149.3,0,139.8,0,128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f8a4ed53840789748d5623eb836c227a.svg";
export { ForwardRef as ReactComponent };